<template>
  <div class="loginWrapper">
    <!------------HTML Containers------------>
    <div
      class="container-fluid loginPageContainer"
      id="content-container"
      :style="loginImage"
    >
      <div class="row loginRow">
        <div class="col-md-4 marginLeft">
          <!------------Page Head---------------->
          <div class="pageHead">
            <h3>
              Interactive
              <b>Research</b>
            </h3>
          </div>
          <!---------Login Form---------------->
          <div class="loginContainer shadow-lg p-3 mb-5 rounded">
            <form v-on:submit.prevent="resetPassword">
              <!----Title------------>
              <h3>Change Password</h3>
              <hr />
              <!-----Login Fields----->
              <!--Login Error Message-->
              <div class="row m-0" v-if="messages">
                <div class="col-md-12 text-center">
                  <ul
                    class="form-errors"
                    v-for="error in messages"
                    :key="error"
                  >
                    <p class="loginError">{{ error }}</p>
                  </ul>
                </div>
                <div class="col-md-12">
                  <!--password-->
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <img :src="passwordimg" class="input-group-text" />
                    </div>
                    <input
                      type="password"
                      class="form-control"
                      v-model="user.password"
                      placeholder="Password"
                      required
                      @keyup="passwordMatch"
                    />
                  </div>
                  <div style="clear: both"></div>
                  <!--password-->
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <img :src="passwordimg" class="input-group-text" />
                    </div>
                    <input
                      type="password"
                      class="form-control"
                      v-model="user.confirmPassword"
                      placeholder="Confirm Password"
                      required
                      @keyup="passwordMatch"
                    />
                  </div>
                  <div style="clear: both"></div>
                </div>
              </div>
              <div style="clear: both"></div>
              <!--Log In-->
              <div class="btnContainer text-center">
                <button class="btn submit" type="submit" :disabled="disabled">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import jquery from "jquery";
//Import Images
import bgImage from "@/assets/img/dbTiles/login.png";
import usernameimg from "@/assets/img/icons/username.png";
import passwordimg from "@/assets/img/icons/password.png";
import { userInputValidation } from "@/helpers/form-validation.js";
export default {
  name: "Resetpassword",
  data() {
    return {
      user: {
        password: "",
        confirmPassword: "",
        id: 0,
        token: "",
      },
      usernameimg: usernameimg,
      passwordimg: passwordimg,
      messages: [],
      loginImage: {
        backgroundImage: "url(" + bgImage + ")",
      },
      errors: {},
      disabled: true,
    };
  },
  mounted() {},
  methods: {
    ...mapActions(["resetpassword"]),
    userInputValidation,
    parseJwt(token) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function(c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    },
    resetPassword() {
      let token = this.$route.params.token;
      // console.log("token===", token);
      // let userinfo = this.parseJwt(token);
      // this.user.id = userinfo["user_id"];
      this.user.token = token;
      this.resetpassword(this.user);
    },
    passwordMatch() {
      let password = this.userInputValidation(this.user.password);
      let confirmPassword = this.userInputValidation(this.user.confirmPassword);
      this.user.password = "";
      this.user.confirmPassword = "";
      this.user.password  = password;
      this.user.confirmPassword  = confirmPassword;
      // console.log("password");
      if (this.user.password == "" || this.user.confirmPassword == "") {
        this.disabled = true;
        this.messages = [];
        return false;
      }
      if (
        this.user.password === this.user.confirmPassword &&
        this.user.password != "" &&
        this.user.confirmPassword != ""
      ) {
        this.disabled = false;
        this.messages = [];
      } else if (this.user.password != "" && this.user.confirmPassword != "") {
        // console.log("password no match");
        this.messages = [];
        this.messages.push("Password does not match!");
        this.disabled = true;
      }
    },
  },
};
</script>

<style lang="scss">
/*********************Page Background************************/
.loginWrapper {
  height: 100%;
}

.loginPageContainer {
  position: relative;
  background-size: cover;
  overflow: hidden;
  height: 100%;
  width: 100%;
}

/**********************Login Container***************************/

.loginRow {
  margin-top: 9rem !important;
  position: relative;
  height: 78%;
}

.col-md-4 {
  height: 100%;
}

.marginLeft {
  margin-left: 10rem !important;
}

.pageHead h3 {
  color: $color-white;
  text-align: center;
  font-size: 35px;
}

.loginContainer:before {
  position: absolute;
  content: "";
  display: block;
  width: 0;
  height: 0;
  left: 50%;
  margin-left: -20px;
  margin-top: -65px;
  border: 20px solid transparent;
  border-bottom: 30px solid rgb(236, 236, 236);
}

.loginError {
  color: $color-red;
  font-size: 12px;
  left: 0;
  margin-bottom: 0 !important;
}

/**********************Login Form***************************/

.loginContainer {
  .col-md-12 {
    padding: 0 15px !important;
  }

  h3 {
    text-align: center;
    font-size: 20px;
    /* line-height: 200px; */
    color: $color-dark-grey;
    font-family: "Arial";
  }

  hr {
    width: 252px;
    height: 1px;
    filter: drop-shadow(0px 1px 0px $color-white);
    background-color: #acacac;
  }

  margin: 70px auto;
  width: 293px;
  min-height: 283px;
  background-image: linear-gradient(0deg, #cccccc 0%, #ffffff 100%);
  border: 1px solid rgba(158, 158, 158, 0.4);
}

.input-group > .custom-file,
.input-group > .custom-select,
.input-group > .form-control,
.input-group > .form-control-plaintext {
  width: 154px;
  height: 29px;
  font-size: 12px;
  color: #494848 !important;
  font-family: "Arial";
}

.form-control img {
  width: 12px;
  height: 14px;
}

/*--------------Forgot Password--------------*/

.pswdBtn {
  position: relative;
  width: 93px;
  height: 18px;
  font-size: 11px;
  line-height: 26px;
  color: #6d6d6d;
  font-family: "Arial";
}

.pswdBtn a,
.pswdBtn span {
  color: $color-dark-grey;
  text-decoration: none;
  font-size: 10px;
  font-weight: normal;
  text-transform: capitalize;
}

.pswdBtn a:hover,
.userReg a:hover {
  font-weight: bold;
  color: $base-color;
}

/*--------------Submit--------------*/

.btnContainer {
  line-height: 2;
}

.submit {
  width: 113px;
  height: 29px;
  filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.3));
  border: 1px solid;
  font-size: 14px;
  color: #4d4d4d;
  font-family: "Arial";
  text-align: center;
  filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.3));
  background-color: #a9aaab !important;
  border-color: #a9aaab !important;
  line-height: 1 !important;
}

.box-shadow--2dp {
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.userReg {
  width: 141px;
  height: 18px;
  font-size: 11px;
  color: #6d6d6d;
  font-family: "Arial";
}

.userReg a {
  color: $base-grey;
  text-decoration: underline;
}

/*--------------Checkbox--------------*/

.custom-control-label {
  width: 93px;
  height: 18px;
  font-size: 11px;
  line-height: 26px;
  color: #6d6d6d;
}

.checkboxContainer {
  position: relative;
  cursor: pointer;
  font-size: 1.6vh;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */

.checkboxContainer input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: $base-color;
  border-radius: 2px;
}

/* On mouse-over, add a grey background color */

.checkboxContainer:hover input ~ .checkmark {
  background-color: $base-color;
}

/* When the checkbox is checked, add a blue background */

.checkboxContainer input:checked ~ .checkmark {
  background-color: $base-color;
}

/* Create the checkmark/indicator (hidden when not checked) */

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */

.checkboxContainer input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */

.checkboxContainer .checkmark:after {
  left: 5px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid $color-white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

small {
  font-size: 100%;
}

/*******************Logout**********************/

.logoutText {
  position: relative;
  margin-top: 20%;
  color: #000;
  font-size: 2.3 vh;
  font-family: sans-serif;
}

.logoutText a,
.logoutText span {
  font-weight: bold;
  color: $base-color;
}

.logoutTitle {
  font-weight: normal;
  font-size: 5vh;
  color: $color-dark-grey;
}

/************Forgot Password Modal*******************/

.modal-title {
  text-align: center;
  left: 0;
  width: 100%;
}

.modal-body p {
  font-size: 13px;
  color: $color-green;
  padding-bottom: 10px;
  margin-top: 20px;
  margin-left: 12px;
  font-weight: 600;
}

.emailForm {
  margin: 1rem;
}

.emailForm label {
  font-weight: 600;
  font-size: 12px;
  position: relative;
  display: inline-block;
}

.emailForm input {
  font-size: 12px;
  position: relative;
  display: inline-block;
  width: 60%;
  margin-left: 5px;
}

.otpBtn {
  position: relative;
  cursor: pointer;
  padding: 5px 25px;
  left: 40%;
}
</style>
